
import adminApi from '@/api/admin';
import useAuth from '@/useAuth';
import { reactive, toRefs } from '@vue/composition-api'

const adminNotificationsState = reactive({
    newFeedbackCount: null
});

export default function useAdminNotifications() {

    const { user } = useAuth();

    const getNewFeedbackCount = async () => {

        if (user.value.is_feedback_manager) {
            const response = await adminApi.getFeedbackCount(1);
            if (response.ok) {
                adminNotificationsState.newFeedbackCount = response.data;
            }
        }
    }

    const refreshNewFeedbackCount = () => {
        getNewFeedbackCount();
    }

    const fetch = () => {
        getNewFeedbackCount();
    }

    fetch();

    return {
        ...toRefs(adminNotificationsState),
        refreshNewFeedbackCount
    }
}

